module.exports = __webpack_public_path__ + "static/media/12-video.b19dc9d1.png";